var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4132 6.47998L11.0532 13.6933",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9333 18.2133L22.3867 21.7467",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.198 13.625L6.99187 14.2511C6.33419 14.3796 5.90515 15.0169 6.03359 15.6745L6.53959 18.2656C6.66802 18.9233 7.3053 19.3523 7.96298 19.2239L11.1691 18.5978C11.8268 18.4693 12.2558 17.8321 12.1274 17.1744L11.6214 14.5833C11.4929 13.9256 10.8557 13.4966 10.198 13.625Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63088 18.7386L6.19904 18.823C5.75411 18.9099 5.33178 18.6255 5.24489 18.1806L4.86156 16.2177C4.77467 15.7728 5.059 15.3504 5.50393 15.2636L5.93577 15.1792L6.63088 18.7386Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8667 10.4C23.4267 10.5333 24.7734 11.68 25.08 13.2933C25.3867 14.9066 24.5867 16.48 23.1867 17.1866",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34668 19.1467L10.3867 24.44C10.4533 24.6267 10.6533 24.7333 10.84 24.6933L13.0133 24.2667C13.2667 24.2133 13.4 23.96 13.32 23.72L11.3333 18.56",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3757 5.31245L19.8392 5.41722C19.5718 5.46945 19.3973 5.72856 19.4495 5.99597L22.5571 21.9087C22.6093 22.1761 22.8684 22.3506 23.1358 22.2983L23.6723 22.1936C23.9398 22.1413 24.1142 21.8822 24.062 21.6148L20.9544 5.70208C20.9022 5.43467 20.6431 5.26023 20.3757 5.31245Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseMarketing);
export default __webpack_public_path__ + "static/media/CollapseMarketing.5ed5edd8339c9b51d7e2a04d046d1e71.svg";
export { ForwardRef as ReactComponent };